//node_modules
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Notifications from './components/Notifications'
import Organizations from './components/Organizations'
import UserManagement from './components/UserManagement'

// pages
import UserManagementPage from "./components/UserManagement/UserManagementPage.jsx";
import OrganizationManagementPage from "./components/OrganizationManagement/OrganizationManagementPage.jsx";
import NotificationOptionManagementPage from "./components/NotificationOptionManagement/NotificationOptionManagementPage.jsx";

//components
import SidebarMenu from "../../components/SidebarMenu.jsx";

//styles
import * as styles from "./AdminDashboard.module.css";

function AdminDashboard() {
  return (
    <div className={styles.adminPortal}>
      <SidebarMenu
        menuItems={[
          {
            link: "/app/admin/users",
            id: "users",
            title: "User Management",
            icon: "pi-users",
          },
          {
            link: "/app/admin/notification-options",
            id: "notification-options",
            title: "Notification Options",
            icon: "pi-bell",
          },
          {
            link: "/app/admin/organizations",
            id: "organizations",
            title: "Organizations",
            icon: "pi-building",
          },
        ]}
        title={"Admin Portal"}
      />
      <div className={styles.routeContainer}>
        <Routes>
          <Route path="users" element={<UserManagement />} />
          
          <Route
            path="organizations"
            element={<Organizations />}
          />

          <Route
            path="notification-options"
            element={<Notifications />}
          />

          <Route index element={<Navigate to="users" />} />
          <Route path="*" element={<Navigate to="users" />} />
        </Routes>
      </div>
    </div>
  );
}

export default AdminDashboard;
